import Stack from '@mui/material/Stack'

import { useQuery } from '~/client/hooks/cqrpc'
import AuthButton from '~/client/components/AuthButton'

const PROVIDERS = [
  {
    id: 'github',
    title: 'Github',
  },
  // {
  //   id: 'apple',
  //   title: 'Apple',
  // },
]

export default function OauthAccounts(){
  const query = useQuery('oauth.getMyProviders')
  const disabled = !!query.loading
  const oAuthAccounts = query.result
  return <Stack spacing={1} sx={{width: '400px'}}>
    {PROVIDERS.map(p => {
      const connected = oAuthAccounts && oAuthAccounts.find(oaa => oaa.provider === p.id)
      return <AuthButton {...{
        key: p.id,
        provider: p.id,
        disabled: disabled || connected,
      }}>
        <span>{connected ? 'Connected' : 'Connect'} to </span>
        <span>{p.title}</span>
      </AuthButton>
    })}
  </Stack>
}
